/* eslint "react/no-array-index-key": "off" */ import React, { useMemo } from "react";
import cx from "classnames";
import { twMerge } from "../../../utils";
export var PaginationDots = function(param) {
    var count = param.count, activeIndex = param.activeIndex, className = param.className, onClick = param.onClick;
    var arr = useMemo(function() {
        return new Array(count).fill(null).map(function(_, index) {
            return function() {
                return onClick === null || onClick === void 0 ? void 0 : onClick(index);
            };
        });
    }, [
        count,
        onClick
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        role: "presentation",
        className: twMerge(cx("flex items-center justify-center", className))
    }, arr.map(function(handleClick, index) {
        return /*#__PURE__*/ React.createElement("button", {
            key: index,
            type: "button",
            onClick: handleClick,
            className: twMerge(cx("w-[0.75rem] h-[0.75rem] rounded-full bg-fg-inbetween transition-all shrink-0 text-[0px] mx-3", activeIndex === index && "bg-brand-primary-base"))
        }, index + 1);
    }));
};

//# sourceMappingURL=PaginationDots.js.map